<template>

  <b-form class="mt-3">
    <b-row>
      <!-- TEST DATE -->
      <!-- <b-col cols="12" md="3" >
              <InputFilter :filter="search[0]"/>
            </b-col>
            <b-col cols="12" md="3" >
              <InputFilter :filter="search[0]"/>
            </b-col> -->
      <!-- TEST DATE -->
      <!-- TEST TIME -->
      <!-- <b-col cols="12" md="3" >
              <InputFilter :filter="search[0]"/>
            </b-col>
            <b-col cols="12" md="3" >
              <InputFilter :filter="search[0]"/>
            </b-col> -->
      <!-- TEST TIME -->

      <b-col
        cols="12"
        md="6"
      >
        <InputFilter :filter="search[0]" />
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <InputFilter :filter="search[1]" />
      </b-col>

      <b-col
        v-if="props.mode == 'List'"
        cols="12"
        md="6"
      >
        <InputFilter :filter="search[2]" />
      </b-col>
      <b-col
        v-if="props.mode == 'List'"
        cols="12"
        md="3"
      >
        <InputFilter :filter="search[3]" />
      </b-col>
      <b-col
        v-if="props.mode == 'List'"
        cols="12"
        md="3"
      >
        <InputFilter :filter="search[4]" />
      </b-col>

      <b-col
        v-if="props.mode == 'List'"
        cols="12"
        md="6"
      >
        <InputFilter :filter="search[5]" />
      </b-col>
      <!-- TEST SELECT -->
      <b-col
        v-if="props.mode == 'List'"
        cols="12"
        md="6"
      >
        <InputFilter :filter="search[6]" />
      </b-col>
    <!-- TEST SELECT -->
    </b-row>
    <!-- Action Buttons -->
    <div class="text-center pt-1">
      <b-button
        variant="primary"
        class="mb-1 mb-sm-0 mr-0 mr-sm-1"
      >
        ค้นหา
      </b-button>
      <b-button
        variant="outline-secondary"
        type="reset"
      >
        ล้าง
      </b-button>
    </div>
  </b-form>

</template>

<script>
import {
  BButton, BAvatar, BRow, BCol, BFormGroup, BFormInput, BForm, BFormCheckbox,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import InputFilter from '../../../filters/components/InputFilter.vue'

export default {
  components: {
    BButton,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BFormCheckbox,
    vSelect,
    InputFilter,
  },
  props: {
    mode: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const options = [
      { label: 'อยู่ระหว่างดำเนินการ', value: '1' },
      { label: 'ส่งต่อเรื่อง', value: '2' },
      { label: 'ผู้ร้องยุติเรื่อง', value: '3' },
      { label: 'ยุติเรื่องในชั้นเจ้าหน้าที่', value: '4' },
      { label: 'ยุติเรื่องในชั้นบังคับคดี', value: '5' },
    ]

    const searchList = [
      {
        id: 'receiveCode', label: 'เลขรับแจ้ง / เลขสารบัญ / รหัสติดตามเรื่องหน่วยงานภายนอก', value: '', class: '', style: '', placeholder: 'กรอกเลขรับแจ้ง / เลขสารบัญ / รหัสติดตามเรื่องหน่วยงานภายนอก', type: 'text', options: [],
      },
      {
        id: 'attorneySearch', label: 'ข้อมูลผู้ร้องทุกข์ / ผู้มอบอำนาจ (ชื่อ-นามสกุล/เลขบัตรประชาชน)', value: '', class: '', style: '', placeholder: 'กรอกข้อมูลผู้ร้องทุกข์ / ผู้มอบอำนาจ', type: 'text', options: [],
      },
      {
        id: 'companySearch', label: 'ข้อมูลผู้ถูกร้องทุกข์ / ผู้ประกอบการ  (ชื่อผู้ประกอบการ / เลขนิติบุคคล)', value: '', class: '', style: '', placeholder: 'กรอกข้อมูลผู้ถูกร้องทุกข์ / ผู้ประกอบการ  (ชื่อผู้ประกอบการ / เลขนิติบุคคล)', type: 'text', options: [],
      },
      {
        id: 'startdateSearch', label: 'ช่วงเวลาที่ร้องทุกข์', value: '', class: '', style: '', placeholder: 'จากวันที่', type: 'date', options: [],
      },
      {
        id: 'enddateSearch', label: 'ถึง', value: '', class: '', style: '', placeholder: 'ถึงวันที่', type: 'date', options: [],
      },
      {
        id: 'complainDetail', label: 'รายละเอียดเรื่องร้องทุกข์', value: '', class: '', style: '', placeholder: 'รายละเอียดเรื่องร้องทุกข์', type: 'text', options,
      },
      {
        id: 'complainStatus', label: 'สถานะดำเนินการ', value: '', class: '', style: '', placeholder: 'สถานะดำเนินการ', type: 'select', options,
      },
    ]
    const searchGroup = [
      {
        id: 'receiveCode', label: 'เลขรับแจ้ง / เลขสารบัญ / รหัสติดตามเรื่องหน่วยงานภายนอก', value: '', class: '', style: '', placeholder: 'กรอกเลขรับแจ้ง / เลขสารบัญ / รหัสติดตามเรื่องหน่วยงานภายนอก', type: 'text', options: [],
      },
      {
        id: 'attorneySearch', label: 'ข้อมูลผู้ร้องทุกข์ / ผู้มอบอำนาจ (ชื่อ-นามสกุล/เลขบัตรประชาชน)', value: '', class: '', style: '', placeholder: 'กรอกข้อมูลผู้ร้องทุกข์ / ผู้มอบอำนาจ', type: 'text', options: [],
      },
    ]
    return {
      options,
      search: props.mode == 'List' ? searchList : searchGroup,
      props,
    }
  },
}
</script>
 <style lang="scss" >
@import '@core/scss/vue/libs/vue-select.scss';
</style>
